import {Routes} from '@angular/router';
import {PlayerProfileRegisterComponent} from './components/player-profile-register/player-profile-register.component';
import {PlayerProfileComponent} from './components/player-profile/player-profile.component';
import {AuthGuardPlayerService} from './service/auth-guard-player.service';
import {PlayerProfileOverviewComponent} from './components/player-profile-overview/player-profile-overview.component';
import {
  PlayerProfileDashboardComponent
} from './components/player-profile/player-profile-dashboard/player-profile-dashboard.component';
import {
  PlayerProfileAccountComponent
} from './components/player-profile/player-profile-account/player-profile-account.component';
import {
  PlayerProfileAchievementsComponent
} from './components/player-profile/player-profile-achievements/player-profile-achievements.component';
import {
  PlayerProfileStatisticsComponent
} from './components/player-profile/player-profile-statistics/player-profile-statistics.component';
import {
  PlayerProfileStatisticsMatchesComponent
} from './components/player-profile/player-profile-statistics/player-profile-statistics-matches/player-profile-statistics-matches.component';
import {
  PlayerProfileStatisticsTableComponent
} from './components/player-profile/player-profile-statistics/player-profile-statistics-table/player-profile-statistics-table.component';
import {
  PlayerProfileCalendarComponent
} from './components/player-profile/player-profile-calendar/player-profile-calendar.component';
import {
  PlayerProfilePaymentSuccessComponent
} from './components/player-profile/player-profile-account/player-profile-account-payments/payment-success/player-profile-payment-success.component';
import {
  PlayerProfilePaymentCancelComponent
} from './components/player-profile/player-profile-account/player-profile-account-payments/payment-cancel/player-profile-payment-cancel.component';
import {
  PlayerProfileMessagesComponent
} from './components/player-profile/player-profile-messages/player-profile-messages.component';
import {
  PlayerProfileDashboardHomeComponent
} from './components/player-profile/player-profile-dashboard/player-profile-dashboard-home/player-profile-dashboard-home.component';
import {
  PlayerProfileMyLeaguesComponent
} from './components/player-profile/player-profile-dashboard/player-profile-my-leagues/player-profile-my-leagues.component';

export const PLAYER_PREFIX = '/player';
export const PLAYER_PREFIX_FULL = '/frontend/player';

export const PLAYER_ROUTES: Routes = [
  {
    path: '',
    component: PlayerProfileComponent,
    data: { noPadding: true, hideToolbar: true},
    children: [
      {
        path: '',
        redirectTo: 'register',
        pathMatch: 'full'
      },
      {
        path: 'register',
        component: PlayerProfileRegisterComponent,
        data: { noPadding: true, hideToolbar: true},
      },
      {
        path: 'profile',
        component: PlayerProfileOverviewComponent,
        data: { noPadding: true, hideToolbar: true},
        canActivate: [AuthGuardPlayerService],
        children: [
          {
            path: '',
            redirectTo: 'dashboard/home',
            pathMatch: 'full'
          },
          {
            path: 'dashboard',
            component: PlayerProfileDashboardComponent,
            data: { noPadding: true, hideToolbar: true},
            children: [
              {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
              },
              {
                path: 'home',
                component: PlayerProfileDashboardHomeComponent,
                data: { noPadding: true, hideToolbar: true},
              },
              {
                path: 'my-leagues',
                component: PlayerProfileMyLeaguesComponent,
                data: { noPadding: true, hideToolbar: true},
              }
            ]
          },
          {
            path: 'statistics',
            component: PlayerProfileStatisticsComponent,
            data: { noPadding: true, hideToolbar: true},
            children: [
              {
                path: '',
                redirectTo: 'matches',
                pathMatch: 'full'
              },
              {
                path: 'matches',
                component: PlayerProfileStatisticsMatchesComponent,
                data: { noPadding: true, hideToolbar: true},
              },
              {
                path: 'table',
                component: PlayerProfileStatisticsTableComponent,
                data: { noPadding: true, hideToolbar: true},
              },
              {
                path: 'graph',
                loadComponent: () =>
                  import('./components/player-profile/player-profile-statistics/player-profile-statistics-graph/player-profile-statistics-graph.component')
                    .then(c => c.PlayerProfileStatisticsGraphComponent),
                data: { noPadding: true, hideToolbar: true},
              }
            ]
          },
          {
            path: 'messages',
            component: PlayerProfileMessagesComponent,
            data: { noPadding: true, hideToolbar: true},
          },
          {
            path: 'calendar',
            component: PlayerProfileCalendarComponent,
            data: { noPadding: true, hideToolbar: true},
          },
          {
            path: 'achievements',
            component: PlayerProfileAchievementsComponent,
            data: { noPadding: true, hideToolbar: true},
          },
          {
            path: 'account/payments/success',
            component: PlayerProfilePaymentSuccessComponent,
            data: { noPadding: true, hideToolbar: true},
          },
          {
            path: 'account/payments/cancel',
            component: PlayerProfilePaymentCancelComponent,
            data: { noPadding: true, hideToolbar: true},
          },
          {
            path: 'account',
            component: PlayerProfileAccountComponent,
            data: { noPadding: true, hideToolbar: true},
            children: [
              {
                path: '',
                redirectTo: 'data',
                pathMatch: 'full'
              },
              {
                path: 'data',
                component: PlayerProfileAccountComponent,
                data: { noPadding: true, hideToolbar: true},
              },
              {
                path: 'personalData',
                component: PlayerProfileAccountComponent,
                data: { noPadding: true, hideToolbar: true},
              },
              {
                path: 'payments',
                component: PlayerProfileAccountComponent,
                data: { noPadding: true, hideToolbar: true}
              },
              {
                path: 'links',
                component: PlayerProfileAccountComponent,
                data: { noPadding: true, hideToolbar: true},
              }
            ]
          }
        ]
      }
    ]
  }
];
